export default {"src":"/_next/static/media/gas-station-fill.e9596786.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};